//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Message } from 'element-ui'
export default {
  data() {
    return {
      name:'',
      tableData:[
        {shopName:'1234'}
      ],
      title:'编辑人员',
      addGoodsState:false,
      name:'',
      phone:'',
       //0业务经理1管理员
      managerList:[
        {dStaffType:1,dStaffTypeText:'管理员'},
        {dStaffType:0,dStaffTypeText:'业务经理'},
      ],
      pageSizes:[5, 10, 15, 20],
      pageSizeValue:10,
      total:0,
      pageNo:1,
      msg:{},
      // pagination:false
    }
  },
 mounted(){
    this.info()
  },
  methods:{
    info(state = false){
      if(state){
        this.pageNo = 1
      }
      let data = {
        pageNo:this.pageNo,
        pageSize:this.pageSizeValue,
        dealerId:window.sessionStorage.getItem('dealerId')
      }
      if(this.name !== ''){
        data.staffName = this.name
      }
      this.tableData = []
      this.$axios.post('/mtea/stock/dealer/staffSearch', data).then(res => {
        console.log(res)
        res.records.forEach(e => {
          e.dStaffTypeText = e.dStaffType === 0?'业务经理':e.dStaffType === 1?"管理员":'无'
          e.state = false
        });
        this.tableData = res.records
        this.total = res.total
      })
    },
    cellStyel(row){
      let style = {}
      style['text-align'] = 'center'
      return style
    },
    headerCellStyel(row){
      let style = {}
      style['text-align'] = 'center'
      style['background-color'] = '#f2f2f2'
      return style
    },
    addState(text,row){
      this.title = text
      if(text === '编辑人员'){
        this.msg = {...row}
      }else{
        this.msg = {}
        this.msg.dStaffType = 0
        this.msg.dStaffName = ''
        this.msg.dStaffPhone = ''
      }
      this.addGoodsState = true
    },
      sizeChange(num){
      this.pageSizeValue = num
      this.info()
    },
    currentChange(num){
      this.pageNo = num
      this.info()
    },
    deleteClick(row){
      row.state = false
      let data = {
        dStaffId: row.dStaffId
      }
      data.dealerId = window.sessionStorage.getItem('dealerId')
      this.$axios.post('/mtea/stock/dealer/delStaff', data).then(res => {
        this.$message({
          message: '删除成功！',
          type: 'success'
        });
        this.info()
      })
    },
    saveClick(){
      if(this.msg.dStaffName === ''){
        this.$message('请输入姓名！');
        return
      }
      if(this.msg.dStaffPhone === ''){
        this.$message('请输入手机号！');
        return
      }
      let exp = RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/)
      if(!exp.test(this.msg.dStaffPhone)){
        this.$message('请输入正确的手机号格式！');
        return
      }
      let data = this.msg
      data.DStaffName = data.dStaffName
      data.dealerId = window.sessionStorage.getItem('dealerId')
      this.$axios.post('/mtea/stock/dealer/addStaff', data).then(()=> {
        this.$message({
          message: '保存成功！',
          type: 'success'
        });
        this.addGoodsState = false
        this.info()
      })
    },
  },
}
